import { Type } from "@angular/core";
import { Col, FilteredKeys } from "../../modules/records/models/columns/col";
import { RatingComponent } from "../table-components/rating/rating.component";

export class RatingCol<T extends object> extends Col<
  T,
  Type<RatingComponent<T>>
> {
  constructor(
    columnDef: FilteredKeys<T, RatingComponent<T>["data"]>,
    header?: string,
    sortable?: boolean,
    public datePipeFormat?: string
  ) {
    super(RatingComponent, columnDef, header,undefined,undefined,undefined,sortable);
  }
}
